import { create } from 'zustand';
import type { inferTypeFromStateCreator } from '@epihub/web/src/zustand/types';
import { zustandThemeSlice } from '../theme/theme';
import { type ConversationStoreSlice, createConversationStoreSlice } from './createConversationStoreSlice';
import { createSettingsStoreSlice, type SettingsStoreSlice } from './createSettingsStoreSlice';

export const useGlobalStore = create<
  & inferTypeFromStateCreator<typeof zustandThemeSlice>
  & ConversationStoreSlice
  & SettingsStoreSlice
>((set, ...rest) => ({
  ...zustandThemeSlice(set, ...rest),
  ...createConversationStoreSlice(set, ...rest),
  ...createSettingsStoreSlice(set, ...rest),
}));
